(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardHomeController', Controller);

    Controller.$inject = ['$scope', 'oddService'];

    function Controller($scope, oddService) {

        // ODD Business Units
        oddService.getAvailableBusinessUnits()
            .then(function (businessUnits) {
                $scope.availableODDBusinessUnits = _.orderBy(businessUnits, ['CampaignTypeID', 'TitleEN']);
            });
    }
})();